import { render, staticRenderFns } from "./MedicationUse.vue?vue&type=template&id=3637618f&"
import script from "./MedicationUse.vue?vue&type=script&lang=js&"
export * from "./MedicationUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports